import clsx from 'clsx';

import type { FC, HTMLProps } from 'react';

import s from './TopBarPaginator.module.css';

type TopBarPaginatorProps = HTMLProps<HTMLDivElement> & {
  after?: number;
  before?: number;
};

const TopBarPaginator: FC<TopBarPaginatorProps> = ({ after = 0, before = 0, children, className, ...props }) => (
  <div className={clsx(s.wrapper, className)} {...props}>
    <div className={s.wrapperDotBefore}>
      {Array.from({ length: before })
        .fill(null)
        .map((_, index) => (
          <span key={index} className={clsx(s.dot, s.dotBefore)} />
        ))}
    </div>
    {children}
    <div className={s.wrapperDotAfter}>
      {Array.from({ length: after })
        .fill(null)
        .map((_, index) => (
          <span key={index} className={clsx(s.dot, s.dotAfter)} />
        ))}
    </div>
  </div>
);

export { TopBarPaginator };
